import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";
import { useLang } from "../context/LanguageContext";

// Render the uploaded logo exactly as provided, without color filters or replacements.
export const Logo = ({ to = "/", className = "", height = 44, testid = "logo-img", linkTestid = "logo-link" }) => {
  const { settings } = useSettings();
  const renderedHeight = Math.round(height * 1.1);
  const img = (
    <img
      src={settings?.logo_url || "/logo.png"}
      alt={settings?.brand_name || "Smart Farmland Invest"}
      style={{ height: renderedHeight }}
      className="w-auto object-contain"
      data-testid={testid}
    />
  );
  if (!to) return <span className={`inline-flex items-center ${className}`}>{img}</span>;
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid={linkTestid}>
      {img}
    </Link>
  );
};

// Anniversary badge — content editable from Site Settings
export const AnniversaryBadge = ({ className = "", compact = false, mobileBar = false, testid = "anniversary-badge" }) => {
  const { settings } = useSettings();
  const { tc } = useLang();
  const number = settings?.anniversary_number ?? "";
  const label = tc(settings?.anniversary_label) || "";
  const tagline = tc(settings?.anniversary_tagline) || "";
  if (!number && !label && !tagline) return null;
  return (
    <span className={`inline-flex ${mobileBar ? "flex-row items-center justify-center gap-2" : "flex-col items-start"} select-none leading-none ${className}`} data-testid={testid} aria-label={`${number} ${label} ${tagline}`}>
      <span className={`inline-flex items-baseline ${compact ? "gap-1" : "gap-2"}`}>
        {number && <span className={`font-display italic text-gold leading-none ${mobileBar ? "text-3xl" : compact ? "text-[32px]" : "text-4xl sm:text-5xl"}`}>{number}</span>}
        {label && <span className={`font-display italic text-white/90 leading-none ${mobileBar ? "text-sm" : compact ? "text-[13px]" : "text-lg sm:text-xl"}`}>{label}</span>}
      </span>
      {tagline && (
        <span className={`${mobileBar ? "mt-0 text-[11px]" : "mt-0.5"} font-display italic text-white/75 whitespace-nowrap ${mobileBar ? "" : compact ? "hidden min-[430px]:inline text-[11px]" : "text-[11px] sm:text-xs"}`}>
          {tagline}
        </span>
      )}
    </span>
  );
};
